import { ExtendedContextStore } from "src/typings/flexFramework/FlexDefinitions";
import { AspectRatioEnum, ThumborStore } from "stores/thumbor/ThumborStore";
import { getAttributionAltText } from "components/shared/AttributionText/AttributionText";
import { Image } from "typings/microserviceModels/destination-where-to-stay-flex-module";

export const dxThumborizeImage = (
  thumbor: ThumborStore | null,
  image: Image,
  name: string,
  width: number,
  height: number,
  context: ExtendedContextStore,
  aspectRatio: AspectRatioEnum = AspectRatioEnum.DEFAULT,
  smartCropEnabled: boolean = true,
  qualityPercentage: number
) => {
  const thumborizedImageUrl =
    thumbor && image.mediaUrl
      ? thumbor.safelyGenerateThumborizedImageUrl(
          image.mediaUrl,
          width,
          height,
          context,
          aspectRatio,
          smartCropEnabled,
          qualityPercentage
        )
      : image.mediaUrl;

  return {
    alt: getAttributionAltText(
      image.source,
      image.origin,
      name,
      image.mediaAlt,
      image.attribution && image.attribution.author && image.attribution.author.name,
      image.attribution && image.attribution.license && image.attribution.license,
      image.mediaUrl
    ),
    mediaUrl: thumborizedImageUrl,
    mediaUrlTrimmed: image.mediaUrl,
    originalMediaUrl: image.mediaUrl,
    src: thumborizedImageUrl,
    source: image.source,
    origin: image.origin,
    caption: image.mediaAlt,
    thumbnailSrc: thumborizedImageUrl,
    attribUrl: image.attribution && image.attribution.license.url,
    authorName: image.attribution && image.attribution.author.name,
    authorUrl: image.attribution && image.attribution.author.url,
    licenseSuite: image.attribution && image.attribution.license.suite,
    licenseName: image.attribution && image.attribution.license.name,
    licenseUrl: image.attribution && image.attribution.license.url
  };
};
